import {ZxingJsBarcodeScanner} from './zxing-js-barcode-scanner';
import type {ScannerFactory, ScannerSettings} from '../barcode-scanner.types';
import {StreamBarcodeScanner} from '../stream-barcode-scanner';

/*@ngInject*/
export function zxingJsBarcodeScannerFactory(DEFAULT_SCANNER_SETTINGS: ScannerSettings): ScannerFactory {
    return {
        createScanner: async (videoSourceElement: HTMLVideoElement, settings?: ScannerSettings): Promise<StreamBarcodeScanner> => {
            const usedSettings = settings ?? DEFAULT_SCANNER_SETTINGS;
            const scanner = new ZxingJsBarcodeScanner(videoSourceElement, usedSettings);
            await scanner.lazyInitScanner();
            return new StreamBarcodeScanner(scanner, usedSettings);
        }

    } as ScannerFactory;
}

zxingJsBarcodeScannerFactory.factoryName = 'zxingJsBarcodeScannerFactory';
